import * as React from "react";

function TrophyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M572.1 82.38C569.5 71.59 559.8 64 548.7 64H447.9c.242-12.45.108-23.7-.156-33.02C447.3 13.63 433.2 0 415.8 0H160.2c-17.4 0-31.5 13.63-32 30.98-1.1 9.32-.4 20.57-.1 33.02H27.26c-11.1 0-20.723 7.59-23.348 18.38C3.1 85.78-15.71 167.2 37.07 245.9c37.44 55.82 100.6 95.03 187.5 117.4 18.7 4.805 39.42 22.23 39.42 41.54 0 .008 0-.008 0 0L264 464h-80c-13.25 0-23.1 10.75-23.1 24s9.9 24 23.1 24h207.1c13.25 0 23.1-10.75 23.1-24s-10.75-24-23.1-24H312v-59.24c.031-19.29 20.72-36.68 39.41-41.48 86.96-22.34 150.1-61.55 187.5-117.4 52.79-78.68 33.99-160.1 33.19-163.5zM77.41 219.8c-27.94-41.2-30.4-84.1-29.03-107.8h80.39c5.359 59.62 20.35 131.1 57.67 189.1-49.04-19.5-85.54-46.7-109.03-81.3zM288 352c-55.7-62.3-112.3-121.1-112-304h223.1c1.2 182.8-55.4 241.6-111.1 304zm210.6-132.2c-23.44 34.6-59.94 61.75-109 81.22C426.9 243.1 441.9 171.6 447.2 112h80.39c.51 23.7-1.09 66.7-28.99 107.8z"
  }));
}

const ForwardRef = React.forwardRef(TrophyIcon);
export default ForwardRef;